// Drop-in fetch replacement that handles credit-related 402 responses
// by dispatching a global ce:creditError event. App.js listens and shows
// OutOfCreditsModal once.
//
// Also auto-emits ce:creditsChanged on successful (2xx) responses to URLs
// that we know deduct credits, so the pill refreshes without per-call wiring.
//
// Returns null on credit error so callers can early-return cleanly.
// Returns the Response object on everything else.

const CREDIT_ENDPOINTS = [
  '/detect-signals',
  '/generate-sequence',
  '/icp-company-import',
  '/icp-company-search',
  '/intelligence/sweep',
  '/generate-icp',
  '/discovery/generate',
  '/enrich',
  '/find-or-create-company',
];

function isCreditEndpoint(url) {
  return CREDIT_ENDPOINTS.some(p => url.includes(p));
}

export async function creditAwareFetch(url, opts) {
  const response = await fetch(url, opts);
  if (response.status === 402) {
    try {
      const data = await response.clone().json();
      // Branch on backend error type so the right modal opens.
      // limit_reached → ce:limitError → LimitReachedModal (links to /pricing)
      // anything else (insufficient_credits etc.) → ce:creditError → OutOfCreditsModal
      const eventName = data?.error === 'limit_reached' ? 'ce:limitError' : 'ce:creditError';
      window.dispatchEvent(new CustomEvent(eventName, { detail: data }));
    } catch {
      window.dispatchEvent(new CustomEvent('ce:creditError', { detail: { error: 'insufficient_credits' } }));
    }
    return null;
  }
  // Auto-refresh the pill on successful credit-burning calls
  if (response.ok && isCreditEndpoint(url)) {
    try { window.dispatchEvent(new CustomEvent('ce:creditsChanged')); } catch {}
  }
  return response;
}

export function emitCreditsChanged() {
  try { window.dispatchEvent(new CustomEvent('ce:creditsChanged')); } catch {}
}
